import React from "react"
import PageHeader from "../../Elements/PageHeader";
import {useLocation, useParams} from "react-router-dom";
import {IRouteParams} from "../../../contracts/router";
import {IRouterListToData} from "../../../contracts/data/router";
import CommentForm from "../../../forms/dashboard/comment/CommentForm";
import {RouterStateSectionType} from "../../../constans/enumTypes";
import useQuery from "../../../hook/useQuery";


const UpdateCommentForm:React.FC = () => {
    const queryParams = useQuery()
    const params:IRouteParams = useParams()
    const location = useLocation<IRouterListToData>()

    return(
        <React.Fragment>
            <PageHeader title={"ویرایش نظر"} isBackBtn
                        urlBackBtn={`${location?.state?.page}?page_num=${location?.state?.page_num}${location?.state?.section === RouterStateSectionType.USER ? "&id=" + location?.state?.userId : ""}&name=${queryParams.get('name')}`}
            />
            <div>
                <CommentForm formType={params.type!} />
            </div>
        </React.Fragment>
    )
}

export default UpdateCommentForm